<form [formGroup]="form">
    <ng-container *ngFor="let field of fields">
        <ng-container *ngIf="field.show || field.showOnRegister">
            <container-element [ngSwitch]="field.type">
                <mat-form-field class="full-width" *ngSwitchCase="'Date'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        [required]="field.required"
                        [readonly]="!editMode"
                        [matDatepicker]="picker"
                        (focus)="picker.open()"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker touchUi #picker startView="multi-year"></mat-datepicker>
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width" *ngSwitchCase="'Number'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        [required]="field.required"
                        [readonly]="!editMode"
                        mask="0*"
                    />
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width" *ngSwitchCase="'CNPJ'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        mask="00.000.000/0000-00"
                        [required]="field.required"
                        [readonly]="!editMode"
                        [dropSpecialCharacters]="false"
                    />
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width" *ngSwitchCase="'CPF'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        mask="000.000.000-00"
                        [required]="field.required"
                        [readonly]="!editMode"
                        [dropSpecialCharacters]="false"
                    />
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width" *ngSwitchCase="'Phone'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        mask="(00) 0000-0000||(00)0 0000-0000"
                        [required]="field.required"
                        [readonly]="!editMode"
                        [dropSpecialCharacters]="false"
                    />
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>

                <div style="margin-bottom: 15px" fxLayoutGap="10px" *ngSwitchCase="'File'">
                    <ngx-spinner name="uploadingFile" [fullScreen]="false" type="ball-clip-rotate-multiple">
                    </ngx-spinner>

                    <button
                        mat-raised-button
                        class="save-user-button fuse-white mt-24 mt-md-0"
                        (click)="document.click()"
                        [disabled]="!editMode"
                    >
                        {{ field.fieldName }} {{ !field.required ? "(opcional)" : null }}
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                    <input
                        type="file"
                        [accept]="field?.fileTypes"
                        #document
                        (click)="document.value = null"
                        (change)="setFile(field.fieldName, document)"
                        style="display: none"
                    />

                    <span
                        *ngIf="filesToUpload[field.fieldName] && filesToUpload[field.fieldName] != ''"
                        fxLayoutGap="10px"
                    >
                        <ngx-spinner name="loadingFile" [fullScreen]="false" type="ball-clip-rotate-multiple">
                        </ngx-spinner>

                        {{ field.fieldName }}

                        <mat-icon style="cursor: pointer" (click)="deleteFile(field.fieldName)"> delete </mat-icon>
                    </span>

                    <span *ngIf="signedUrls[field.fieldName] && signedUrls[field.fieldName] != ''" fxLayoutGap="10px">
                        <a [href]="signedUrls[field.fieldName]" target="_blank">
                            <mat-icon>remove_red_eye</mat-icon>
                        </a>
                        <mat-icon *ngIf="editMode" style="cursor: pointer" (click)="deleteFile(field.fieldName)">
                            delete
                        </mat-icon>
                    </span>
                </div>

                <mat-form-field class="full-width" *ngSwitchCase="'Select'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [multiple]="false" [formControlName]="field.key" [required]="field.required">
                        <ngx-spinner name="select" [fullScreen]="false" type="ball-clip-rotate-multiple"> </ngx-spinner>
                        <input
                            [id]="'input_search'"
                            [placeholder]="'USER_CUSTOM_FIELDS.SELECT.SEARCH' | translate"
                            class="select-search"
                            matInput
                            #filterSelect
                            (keyup)="GetSelectOptions(field.id, filterSelect.value)"
                        />

                        <mat-option
                            *ngFor="let option of GetSelectOptionsToList(field.fieldName)"
                            [value]="option.value"
                        >
                            {{ option.value }}
                        </mat-option>
                        <mat-option disabled *ngIf="GetSelectOptionsToList(field.fieldName).length <= 0">
                            {{ "USER_CUSTOM_FIELDS.SELECT.EMPTY_OPTIONS" | translate }}
                        </mat-option>
                        <mat-option disabled *ngIf="GetSelectOptionsToList(field.fieldName).length > 50">
                            {{ "USER_CUSTOM_FIELDS.SELECT.SEARCH" | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="full-width" *ngSwitchCase="'MultiSelect'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <ngx-spinner name="select" [fullScreen]="false" type="ball-clip-rotate-multiple"> </ngx-spinner>
                    <mat-chip-list #chipList [formControlName]="field.key">
                        <mat-chip
                            *ngFor="let option of GetSelected(field.fieldName)"
                            [selectable]="true"
                            [removable]="true"
                            (removed)="removeSelected(option)"
                        >
                            {{ option.value }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                            [id]="'input_search'"
                            [placeholder]="'USER_CUSTOM_FIELDS.SELECT.SEARCH' | translate"
                            #filterMuiltiSelect
                            (keyup)="GetSelectOptions(field.id, filterMuiltiSelect.value)"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        />
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                        <mat-option *ngFor="let option of GetSelectOptionsToList(field.fieldName)" [value]="option">
                            {{ option.value }}
                        </mat-option>
                        <mat-option disabled *ngIf="GetSelectOptionsToList(field.fieldName).length <= 0">
                            {{ "USER_CUSTOM_FIELDS.SELECT.EMPTY_OPTIONS" | translate }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <div *ngSwitchCase="'Address'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <app-address-form #addressForm [Address]="Address" [IsRequired]="field.required"></app-address-form>
                </div>

                <mat-form-field class="full-width" *ngSwitchDefault>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input
                        [id]="field.fieldName"
                        [formControlName]="field.key"
                        matInput
                        type="text"
                        [required]="field.required"
                        [readonly]="!editMode"
                    />
                    <mat-error *ngIf="form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.REQUIRED" | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get(field.key).invalid && !form.get(field.key).hasError('required')">
                        {{ "USER_CUSTOM_FIELDS.MESSAGES.INVALID" | translate }}
                    </mat-error>
                </mat-form-field>
            </container-element>
        </ng-container>
    </ng-container>
</form>
